var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxCircle = function SvgCheckboxCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#80C46B",
    d: "M15.636 2.455c7.603 0 13.774 6.172 13.774 13.776 0 7.603-6.17 13.774-13.774 13.774S1.86 23.835 1.86 16.23 8.032 2.454 15.636 2.454M12.88 19.22l-4.944-4.932-1.943 1.942 6.887 6.888L25.278 10.72l-1.942-1.956z"
  })));
};
export default SvgCheckboxCircle;